 export const API_URL = 'https://gms.homeon.vn'
export const LIVE_STREAM_URL = 'https://gms.homeon.vn'
export const PLAYBACK_URL = 'https://gms.homeon.vn'
export const MQTT_URL = 'wss://gms.homeon.vn/mqtt'

export const APP_NAME = 'homeOn';
export const APP_TITLE = 'HỆ THỐNG QUẢN LÝ TẬP TRUNG';
export const EMAIL_SERVER = "giamsat@homeon.vn";
export const POWER_BY = "homeOn ©2018 Powered by SMATEC JSC."



// WEBPACK FOOTER //
// ./src/constants/configValues.js